import { ExternalToolWebLinkTypes } from 'redux/schemas/models/external-tool';

/* @ngInject */
export default function WebEmbedLectureComponentModel(
  EmbedLectureComponentModel,
) {
  return EmbedLectureComponentModel.create(ExternalToolWebLinkTypes.WEB_EMBED);
}
